export const Text = {
  SummaryAbout: 'About - Summary',
  Summary: 'Summary',
  SpokenLanguages: 'Spoken Languages',
  Experience: 'Experience',
  Role: 'Role',
  DisciplinePermission: 'Discipline Permission',
  LocationPermission: 'Location Permission',
  Grade: 'Grade',
  DU: 'DL',
  CoreSkill: 'Core Skill',
  CoreSkills: 'Core Skills',
  SkillsQualifications: 'Skills & Qualifications',
  ProgramingLanguages: 'Programing Languages',
  ToolsTechniques: 'Tools & Techniques',
  UpdateCompletions: 'Update & Completions',
  LastUpdateFrom: 'Last Update From',
  LastUpdateTo: 'Last Update To',
  Developer: 'Developer',
  JavaScript: 'JavaScript',
  Required: 'This field is required',
  ValidDate: 'Must be a valid date',
  specialCharactersNotAllowed: 'Special characters are not allowed',
  SpellErrors: 'Spelling errors must be solved before saving',
  Title: '* Title',
  JobTitle: 'Job Title',
  Company: 'Company',
  IndustrySector: 'Industry Sector',
  ExperienceIndustrySector: 'Experience - Industry Sector',
  ProjectName: 'Project Name',
  ProjectDescription: 'Project Descriptions / Project Objectives',
  AdditionalInfo: 'Additional Information',
  AdditionalInfoDesc: 'Additional Information Description',
  AdditionalInfoTooltipMessage:
    'The information in this section is only included in the Summary template. You can use this field to add additional information you want to show about each project in your experience, e.g., features, goals, etc.',
  OnePageCheckboxTooltipMessage:
    'Only marked experiences are included in the summary template. A maximum of 5 can be selected.',
  Achievements: 'Achievements / Challenges',
  TemplateDescription: 'Template Description',
  TemplateUrl: 'URL',
  EditExperience: 'Edit Experience',
  JobResponsibilities: 'Job Description / Responsibilities',
  JobAndResponsibilities: 'Job Description and Responsibilities',
  From: '* Date From',
  ToRequired: '* To',
  To: 'To',
  Delete: 'Delete',
  DeleteItem: 'Delete Item',
  Create: 'Create',
  CreateItemMessage: 'Create [[item]]',
  EditItemMessage: 'Edit [[item]]',
  UniqueValueMessage: "The value is equal to the old one, there's no need to update the values",
  DeleteItemMessage: 'Delete [[item]]',
  DeleteConfirmItemMessage:
    'You are going to delete <strong>[[item]]</strong>.<br> Click <strong>Delete</strong> if you want to Continue.',
  DeleteRole: 'Delete Role',
  DeleteAlertItemMessage: 'Are you sure you want to delete this item?',
  AddAlertItemMessage: 'Are you sure you want to save and add this item',
  RoleWarningTitle: 'Duplicated Role [role_name]',
  RoleWarningMessage: 'The role name, <strong>[role_name]</strong>, is already in use. Please try a different name.',
  RolePermisionWarningMessage:
    "This role can't be created because an existing role called, <strong>[role_name]</strong>, already has the same permissions. Please try using that one.",
  Alert: 'Alert!',
  DeleteMessage: 'You are going to delete the selected item.<br> There are no undo actions for this.',
  DeleteUserMessage: 'Are you sure to delete the user profile?',
  DeleteRoleMessage: 'Are you sure to delete the role?',
  MessageToDelete: 'All changes related to <strong>[[item]]</strong> are irrevocable.',
  Languages: 'Languages',
  Language: 'Language',
  Level: 'Level',
  Levels: 'Levels',
  TechLevels: 'Technical Levels',
  SelectLanguage: 'Select a language',
  SelectOption: 'Select Option',
  Select: 'Select',
  SelectLocation: 'Select Location',
  ProgrammingLanguages: 'Programming Languages',
  DB: 'Databases',
  Domains: 'Industry Verticals',
  Frameworks: 'Tools & Techniques',
  SkillName: 'Name',
  Testing: 'Testing',
  Technologies: 'Technologies',
  SoftSkills: 'Soft Skills',
  Repository: 'Repository',
  LinkedInProfile: 'LinkedIn Profile URL',
  GitHubProfile: 'GitHub Profile URL',
  TechnicalSkills: 'Technical Skills',
  Hobbies: 'Hobbies',
  Education: 'Educational Background',
  EducationBackgroundDegreeTitle: 'Educational Background - Degree Title',
  EducationInstitution: 'Educational Institution',
  PlaceEducation: 'University or School',
  Degree: 'Degree title',
  EndingYear: 'Ending Year',
  Status: 'Status',
  Finished: 'Finished',
  NotFinished: 'Not Finished',
  Currently: 'In Progress',
  Certifications: 'Certifications',
  CertificationTitle: 'Certification Title',
  CertifyingEntity: 'Certifying Entity',
  Edit: 'Edit My Profile',
  Audit: 'Audit My Profile',
  RolesPermissions: 'Roles & Permissions',
  Add: 'Add',
  Update: 'Update',
  Code: 'Code',
  Name: 'Name',
  Country: 'Country',
  SelectionCriteria: 'Selection Criteria',
  DeliveryLocation: 'Delivery Location',
  Email: 'Email',
  SinceDate: 'Joining Date',
  Description: 'Description',
  Databases: 'Databases',
  URL: 'URL',
  LastName: 'Last Name',
  MaxLength: 'Max length exceeded',
  Profiles: 'My Team',
  ListManagement: 'List Management',
  TemplatesList: 'Templates URL',
  ViewProfile: 'View My Profile',
  AdminPanel: 'Admin Panel',
  RoleManager: 'Role Manager',
  Users: 'Users',
  SelectRole: 'Select a Role',
  Support: 'Support',
  Collapse: 'Collapse',
  Menu: 'Menu',
  NotProfile: 'Without info',
  NotInfo: "You don't have data recorded in your profile, press edit and add it!",
  LoadingPDF: 'Please wait a moment while we prepare your file...',
  GenericLoading: 'Loading...',
  RoleChangedWarning: 'User’s role was changed, but they might lose certain permissions.',
  GlobalSearchPlaceholder: 'Search by keyword...',
  AdvancedSearch: 'Filter By',
  AdvancedSearchAppliedFilters: 'Applied filters',
  AdvancedSearchTitle: 'Filter By',
  AdvancedSearchClose: 'X',
  AdvancedSearchButton: 'Filter',
  AdvancedSearchProfileCompletionPercentaje: 'Profile completion percentage',
  AdvancedSearchApplyButon: 'Apply',
  AdvancedSearchPeopleStatusLabel: 'People status',
  ExportButton: 'Export',
  AdvancedSearchCancelButton: 'Clear All',
  AdvancedSearchSkilsQualifications: 'Skills & Qualifications',
  PaginationShowing: 'Showing',
  PaginationFrom: 'from',
  ExportTo: 'Export',
  ExportToPDF: 'to PDF',
  ExportToWORD: 'to Word',
  Logout: 'Logout',
  GetPDF: 'How do you want to get the pdf file?',
  GetWORD: 'How do you want to get the word file?',
  Download: 'Download in my computer',
  SendToEmail: 'Send to email',
  SuccessMessage: 'Your file will be sent by email',
  ErrorMessage: 'Import generation failed. Please try again or later',
  InvalidEmail: 'Please enter a valid email address with endava domain',
  SavedMessage: 'Your profile was saved',
  AutoSuccessMessage: 'Your file has been downloaded, please check your downloads',
  Admin: 'Admin',
  Endavan: 'Endavan',
  Actions: 'Actions',
  FileNamePDF: 'EndavaProfile.pdf',
  FileNameWORD: 'EndavaProfileEditable.docx',
  LastUpdate: 'Last Update',
  CompletionPercentage: '% Completion',
  Discipline: 'Discipline',
  Position: 'Position',
  UserType: 'User Type',
  NoResults: 'No results found',
  NoResultsFounded: 'We could not find any results',
  NoResultsDetail: 'Your search was too narrow. Try broadening your search or clear all',
  NoResultsDetail1: 'filters to go back to the default view',
  NewItemAdded: 'New Item added',
  ErrorAddingItem: "The item '[[placeholder]]' you are trying to add already exists in the list",
  ErrorEmptyInput: "Empty spaces cannot be added as '[[placeholder]]'",
  ReleaseNotes: 'Release Notes',
  MyProfile: 'My Profile',
  ExportModalTitle: 'Export Profile',
  ExportModalSelectFormat: 'Select a file format',
  ExportModalSelectTemplate: 'Select a template',
  ExportModalSelectPlaceholder: 'Filter by name',
  ExportModalOk: 'Export',
  ExportModalCancel: 'Cancel',
  ExportModalErrorProps: 'Only one of "profileToExport" and "profilesToExport" should be provided',
  ExportScaleLevels: 'Export Scale Levels',
  ExportMicrosoftWord: 'Microsoft Word',
  ExportAnonymizedTemplate: 'Anonymized Template',
  ExportPDF: 'PDF',
  UpdateValuesFromEwaPlaceholder: 'Is your Profile outdated? click here to update your information',
  TheExportedProfileContentMayDiffer:
    'The View Profile section is a compilation of all the information presented in the profile. Yet, depending on the selected template, the exported profile content may differ from the View Profile content.',
  ProfileParametersUpdatedSuccessMessage: 'Your Profile was updated',
  ProfileParametersUpdatedMessage: 'Your Profile is currently updated, No action needed',
  ProfileImage: 'Profile Image',
  ProfileImageErrorMaximumSize: 'The maximum size allowed for the image is 2MB',
  ProfileImageErrorIncorrectExtension: 'Image should be a .jpg',
  ErrorSavingMessage: '* Please complete all the required fields before saving',
  ExperienceEndava: 'Project within Endava',
  ExperienceExternal: 'Project with previous employer',
  SupportEmailsHaveNoDifferences: "The new addresses are equal to the old ones, there's no need to update the values",
  DefaultSupportEmail: 'profile@endava.com',
  DefaultErrorMessageSupportEmail: 'Was not possible to validate your Country. Initial values cannot be changed',
  TechnicalSkillsTooltip:
    'The information in this section is only included in the Summary template. You can use this field to add additional technical skills you have experience in, e.g., Unity Development, Agile Expert, etc.',
  ExportProfile: 'Export profile',
  CopyProfileUrl: 'Copy URL to clipboard',
  ViewUserProfile: 'View profile',
  DeleteUserProfile: 'Delete profile',
  CopiedProfileUrl: 'Profile URL Copied!',
  SelectSummaryTemplate: 'Select for Summary Template',
  HiddenSummaryTemplate: 'Not included in Summary template',
  EditRole: 'Edit Role',
  CannotDeleteAdmin: 'The Administrator role cannot be deleted',
  CannotDeleteRole: 'This role cannot be deleted',
  ForAddingNewOptionsContactHead: 'For adding a new option, please contact the Head of the discipline.',
  Completion: 'Completion',
  CompletionTo: 'Completion to',
  SelectAFile: 'Select a file',
  DeleteProfileImage: 'Are you sure you want to delete your profile image?',
  Confirm: 'Confirm',
  Cancel: 'Cancel',
  ProfileImageTooltipMessage:
    'You can add your profile photo in the summary section - Edit My Profile. Not all the available templates include the photo when the profile is exported',
  // list Managment contants
  ListManagmentItemIsEqualWarning: '[[item]] is already in the list and does not require an update',
  ListManagmentItemCreatedIsEqualWarning: '[[item]] is already in the list and does not require to be created',
  ListManagmentItemCreatedIsEmptyWarning: '[[item]] is empty',
  ListManagmentItemCreated: '[[item]] was created',
  ListManagmentItemNotCreated: '[[item]] was not created',
  ListManagmentItemCreationError: 'Create [[item]] failed',
  ListManagmentItemEdited: '[[item]] was edited',
  ListManagmentItemNotEdited: '[[item]] was not edited',
  ListManagmentItemEditionError: 'Edit [[item]] failed',
  ListManagmentItemDelete: '[[item]] was deleted',
  ListManagmentItemNotDelete: '[[item]] was not deleted',
  ListManagmentItemDeleteError: 'Delete [[item]] failed',
  ListManagmentItemDeleteVarious: '[[item]] were deleted',
  ListManagmentItemNotDeleteVarious: '[[item]] were not deleted',
  ListManagmentItemDeleteVariousError: 'Delete [[item]] failed',
  Hobbie: 'Hobby',
  TechLevel: 'Tech level',
  Degrees: 'Degree titles',
  Certification: 'Certification',
  IndustrySectors: 'Industry sectors',
  IndustryVertical: 'Industry vertical',
  IndustryVerticals: 'Industry verticals',
  ProgrammingLanguage: 'Programming language',
  Database: 'Database',
  TechnicalSkill: 'Technical skill',
  SoftSkill: 'Soft skill',
  Hobby: 'Hobby',
  TechnicalLevels: 'Technical level',
  ToolsAndTechniques: 'Tools & techniques',
  ToolAndTechnique: 'Tool & technique',
  // New strings for edit profile
  AreYouSureYouWantToChangeYourOwnRole: 'Are you sure you want to change your own role?',
  beAwareYouAreChangingYourOwnRole: 'Please be aware you are making changes to your own role.',
  EmptyRoleNameTitle: 'Empty Role',
  EmptyRoleNameErrorMessage: 'Role name cannot be empty. Please provide a valid name for the role.',
  EmptyRoleArrayTitle: 'No permissions selected',
  EmptyRoleArrayErrorMessage: 'You have to choose at least one permission for the role',
  // Header
  LogoText: 'Endava Profile',
  LogoutButton: 'Logout',
  // Confirm delete profile dialog
  DeleteModalTitle: 'You are deleting a profile',
  DeleteModalDescription: 'Are you sure you want to delete it? This action cannot be undone.',
  // Pagination control
  PageControlPageTitle: 'Page',
  PageControlPreviousPageTitle: 'Previous page',
  PageControlNextPageTitle: 'Next page',
  // Nested Select
  Placeholder: 'Placeholder',
  // Users
  UsersGlobalSearch: 'Search by name',
  // UsersAdvancedFilters
  UsersAdvancedFiltersTitle: 'Filter By',
  UsersAdvancedFiltersAppliedFilters: 'Applied filters:',
  UsersAdvancedFiltersAppliedPermissions: 'Permissions',
  UsersAdvancedFiltersUserLabelSelected: 'Selected',
  UsersAdvancedFiltersUserSelectPlaceholder: 'Select',
  UsersAdvancedFiltersUserDeliveryLocation: 'Delivery Location',
  UsersAdvancedFiltersUserGrade: 'Grade',
  UsersAdvancedFiltersUserDiscipline: 'Discipline',
  UsersAdvancedFiltersUserRole: 'Role',
  UsersAdvancedFiltersUserDisciplinePermission: 'Discipline Permission',
  UsersAdvancedFiltersUserLocationPermission: 'Location Permission',
  UsersAdvancedFiltersClear: 'Clear filters',
  UsersAdvancedFiltersApply: 'Apply',
  // Roles
  Roles: 'roles',
  CreateRole: 'Create Role',
  RolesTitle: 'Roles',
  EditRolePermissions: 'Edit Role Permissions',
  CreateRoleDescription: 'Roles allow you to create predetermined accesses and permissions for different purposes',
  RoleLabel: 'Role:',
  RoleHelper: 'This field is mandatory',
  RoleDuplicateName: 'This role already exists. Please choose a different name.',
  ActivePermissionsLabel: 'Active permissions:',
  ActivePermissionsHelperText: 'You need to select at least one permission.',
  ActivePermissionsDuplicatePermission:
    "Role can't be created because the role “{{name}}” already has the same permissions.",
  SaveChanges: 'Save changes',
  EditYourOwnRoleTitle: 'You are editing your own role',
  EditYourOwnRoleDescription:
    'The “{{name}}” role is assigned to you too. Editing it could result in limiting your access to certain features.',
  EditYourOwnRoleContinue: 'Edit anyway',
  ViewRoleTitle: 'View Role Details',
  RoleCreatedBy: 'Role Created by:',
  Resume: 'Professional Resume',
  Confidential: 'Confidential',
  RoleCreatedSuccess: 'Role has been successfully created.',
  RoleModifiedSuccess: 'Role has been successfully modified.',
  RoleDeletedSuccess: 'Role has been successfully deleted.',
  DeleteRoleTitle: 'You are deleting "{{name}}” role',
  DeleteRoleDescription: 'This role has {{count}} users assigned to it. Are you sure you want to delete it?',
  DeleteRoleDescription2: 'Upon deletion, these users will be reverted to Endavan role.',
  UnexpectedErrorOccured: 'Unexpected error occured',
  AdminTooltipText: 'Role manually assigned, granting full control over the application',
  ManagerTooltipText:
    'Role automatically assigned based on Job Title ("Regional Manager", "Country Manager", "DU Manager"), granting management access and permissions',
  HeadOfDisciplineTooltipText:
    'Role automatically assigned based on Job Title ("Head of"), granting management access and review permissions',
  LeadTooltipText: 'Role manually assigned, granting access and review permissions',
  EndavanTooltipText: 'Role automatically assigned, granting basic access'
}
